import React, { useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  InputAdornment,
  Paper,
  Grid,
} from "@mui/material";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import AtithiLogo from ".././../././../assets/Atithiseva-Logo-Final-1024x298.png";
import TextInputField from "../../../component/ui/FormFields/TextInputField";
import "../../../styles/AuthStyles.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useDispatch, useSelector } from "react-redux";
import {
  LOGIN,
  VERIFY_EMAIL,
} from "../../../component/common/Routes/AppRoutes";
import { resetForgotPasswordState } from "../actions/authActions";
import CustomButton from "../../../component/ui/FormFields/Button";

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const forgotPasswordState = useSelector((state) => state.forgotPassword);
  const { loading, message, error } = forgotPasswordState || {};

  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm();
  const email = watch();

  const navigate = useNavigate();

  const onSubmit = (data) => {
    dispatch({
      type: "FORGOT_PASSWORD_REQUEST",
      payload: { email: data.email },
    });
  };
  useEffect(() => {
    dispatch(resetForgotPasswordState());
  }, []);
  useEffect(() => {
    if (message) {
      toast.success(message, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetForgotPasswordState());
          navigate(VERIFY_EMAIL, { state: { email: email?.email } }); // Navigate after the toast is closed
        },
      });
    }
  }, [message]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(resetForgotPasswordState());
    }
  }, [error]);

  return (
    <Box className="forgot-password-container">
      <ToastContainer position="top-center" autoClose={5000} />

      <Box className="airplane-icon">
        <AirplanemodeActiveIcon />
      </Box>

      <Container maxWidth="sm">
        <Paper elevation={6} className="paper-container">
          <Box className="logo">
            <img src={AtithiLogo} alt="Atithiseva Logo" />
          </Box>
          <Box className="heading">
            <Typography variant="h5" mt={5} textAlign={"center"}>
              Reset Your Password
            </Typography>
            <Typography variant="body1" mb={2} mt={3} textAlign={"center"}>
              Enter your email to receive a password reset link.
            </Typography>
          </Box>

          <form
            onSubmit={handleSubmit((data) => {
              if (!errors.email) {
                onSubmit(data);
              }
            })}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter a valid email address",
                    },
                  }}
                  render={({ field, fieldState }) => (
                    <TextInputField
                      {...field}
                      label="Email Address"
                      placeholder="Enter your email"
                      fullWidth
                      error={!!fieldState.error}
                      helperText={fieldState.error?.message}
                      startAdornment={
                        <InputAdornment position="start">
                          <MailOutlineIcon color="primary" />
                        </InputAdornment>
                      }
                      variant="outlined"
                      className="email-input"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomButton
                  variant="contained"
                  className="send-reset-link-button"
                  type="submit"
                  size="large"
                  fullwidth={true}
                  loading={loading}
                  text={"Send Reset Link"}
                />
                {/* <Button
                  type='submit'
                  fullWidth
                  size='large'
                  className='send-reset-link-button'
                  disabled={loading}
                >
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </Button> */}
              </Grid>
            </Grid>
          </form>

          <Button
            variant="text"
            fullWidth
            className="back-to-login-button"
            onClick={() => {
              navigate(LOGIN);
            }}
          >
            Back to Login
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}
